/**
 * @file DemoImg
 * @author zhaomiaoyuan
 */
import React from 'react';
import './index.less';

interface Props {
    img: string;
    setPreview(o?: any): void;
}

export default function DemoImg(props: Props) {
    const {
        img,
        setPreview
    } = props;
    return (
        <div className="upload-proof-demo"
            onClick={() => {
                setPreview({
                    visible: true,
                    image: img,
                    title: '上传样例'
                });
            }}>
            <img width={'100%'} height={'100%'} src={img}></img>
            <div className="upload-proof-demo-title">示例</div>
        </div>
    );
}
